import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as NoDataIcon } from 'assets/icons/NoData.svg';

import { useStyles } from '../styles';
import { OnboardingStatus } from 'models/general';

interface EmptyStateProps {
  activeTab: number;
}

const EmptyState: React.FC<EmptyStateProps> = ({ activeTab }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const getEmptyStateMessage = () => {
    switch (activeTab) {
      case OnboardingStatus.PENDING:
        return {
          title: t('workerStatus.emptyState.pending.title'),
          subtitle: t('workerStatus.emptyState.pending.subtitle'),
        };
      case OnboardingStatus.PROCESSING:
        return {
          title: t('workerStatus.emptyState.processing.title'),
          subtitle: t('workerStatus.emptyState.processing.subtitle'),
        };
      case OnboardingStatus.INCOMPLETE:
        return {
          title: t('workerStatus.emptyState.incomplete.title'),
          subtitle: t('workerStatus.emptyState.incomplete.subtitle'),
        };
      case OnboardingStatus.COMPLETED:
        return {
          title: t('workerStatus.emptyState.completed.title'),
          subtitle: t('workerStatus.emptyState.completed.subtitle'),
        };
      default:
        return {
          title: t('workerStatus.emptyState.default.title'),
          subtitle: t('workerStatus.emptyState.default.subtitle'),
        };
    }
  };

  const { title, subtitle } = getEmptyStateMessage();

  return (
    <Box className={classes.emptyState} data-testid="worker-status-empty-state">
      <NoDataIcon />
      <p className={classes.emptyStateTitle} data-testid="worker-status-empty-state-title">
        {title}
      </p>
      <p className={classes.emptyStateSubtitle}>{subtitle}</p>
    </Box>
  );
};

export default EmptyState;
